import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Coarse visibility for the Actions Registry `start-task` action (no resource ref in that check).
 * Fine-grained control uses {@link rithumAgentStartTaskEntityPermission}.
 */
export const rithumAgentStartTaskVisibilityPermission = createPermission({
  name: 'rithum-agent.actions.start-task',
  attributes: { action: 'update' },
});

/**
 * Authorizes starting an agent task for a specific catalog entity (entity owners only via policy).
 */
export const rithumAgentStartTaskEntityPermission = createPermission({
  name: 'rithum-agent.catalog-entity.start-task',
  attributes: { action: 'update' },
  resourceType: 'catalog-entity',
});
